module["exports"] = [
  "#{street_suffix} #{Name.first_name}",
  "#{street_suffix} #{Name.first_name} #{Name.last_name}",
  "#{street_suffix} #{street}",
  "#{street_suffix} #{street}",
  "#{street_suffix} #{street}",
  "#{street_suffix} #{street}"

];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/address/street_name.js
// module id = 1396
// module chunks = 0